import { useEffect } from 'react';

const AnalyticsLoader = ({ cookieAccepted }) => {
  useEffect(() => {
    if (!cookieAccepted) return;

    // -- LiveChat
    window.__lc = window.__lc || {};
    window.__lc.license = 11578458;

    const lcScript = document.createElement('script');
    lcScript.type = 'text/javascript';
    lcScript.async = true;
    lcScript.src = 'https://cdn.livechatinc.com/tracking.js';
    document.head.appendChild(lcScript);

    // -- Poll for LC_API readiness
    const interval = setInterval(() => {
      if (window.LC_API && typeof window.LC_API.open_chat_window === 'function') {
        clearInterval(interval);
        // Optionally trigger the widget
        // window.LC_API.open_chat_window();
      }
    }, 500);

    // -- Heap
    window.heap = window.heap || [];
    window.heap.load = function (envId, config) {
      window.heap.envId = envId;
      window.heap.clientConfig = config || {};
      window.heap.clientConfig.shouldFetchServerConfig = false;

      const heapScript = document.createElement('script');
      heapScript.type = 'text/javascript';
      heapScript.async = true;
      heapScript.src = `https://cdn.us.heap-api.com/config/${envId}/heap_config.js`;
      document.head.appendChild(heapScript);

      const methods = [
        'init', 'startTracking', 'stopTracking', 'track', 'resetIdentity',
        'identify', 'getSessionId', 'getUserId', 'getIdentity',
        'addUserProperties', 'addEventProperties', 'removeEventProperty',
        'clearEventProperties', 'addAccountProperties', 'addAdapter',
        'addTransformer', 'addTransformerFn', 'onReady',
        'addPageviewProperties', 'removePageviewProperty', 'clearPageviewProperties',
        'trackPageview'
      ];

      const stub = (method) => function () {
        const args = Array.prototype.slice.call(arguments);
        (window.heap.q = window.heap.q || []).push([method, ...args]);
      };

      methods.forEach((method) => {
        window.heap[method] = stub(method);
      });
    };

    window.heap.load('3287964440'); // Replace with your Heap ID

    return () => clearInterval(interval);
  }, [cookieAccepted]);

  return null;
};

export default AnalyticsLoader;

